import { set, lensProp } from 'ramda';

import {
  HANDLE_TYPE_PRICE_LINK_LOADING,
  SET_TYPE_PRICE_LINK,
  SET_TYPE_PRICE_LINK_ERRORS,
  CLEAR_TYPE_PRICE_LINK_ERRORS
} from './constants';

const defaultState = {
  isLoading: false,
  errors: {
    typePriceLink: null
  },
  submit: {
    typePriceLink: []
  }
}

export default (state = defaultState, action) => {
  switch (action.type) {
    case HANDLE_TYPE_PRICE_LINK_LOADING: {
      return set(lensProp('isLoading'), action.status, state);
    }
    case SET_TYPE_PRICE_LINK: {
      return {
        ...state,
        submit: {
          ...state.submit,
          typePriceLink: [action.typePriceLink]
        }
      }
    }
    case SET_TYPE_PRICE_LINK_ERRORS: {
      return {
        ...state,
        errors: {
          typePriceLink: action.errors?.typePricesLink ? action.errors?.typePricesLink[0] : null
        }
      }
    }
    case CLEAR_TYPE_PRICE_LINK_ERRORS: {
      return {
        ...state,
        errors: {}
      }
    }
    default: {
      return state;
    }
  }
}